export const CARD_ADD_FAILED = 'CARD_ADD_FAILED';
export const BILLING_ADDRESS = 'BILLING ADDRESS';
export const BILLING_ADDRESS_REQUIRED = 'BILLING_ADDRESS_REQUIRED';
export const ENROLL_THE_USER = 'ENROLL THE USER';
export const CARD_ALREADY_EXISTS = 'CARD ALREADY EXISTS';
export const IDENTITY_VALIDATION_REQUIRED = 'IDENTITY_VALIDATION_REQUIRED';

export const ENROLL_FAILURE_MESSAGES = {
  BILLING_ADDRESS_REQUIRED: 'Unable to proceed with Enrollment as Billing Address is invalid.',
  CARD_ADD_FAILED: 'One or more required parameter missing, please check missing fields',
  CARD_ALREADY_EXISTS_ERROR: 'Card already exists with email address or mobile number',
  IDENTITY_VALIDATION_REQUIRED: 'Consumer Identity validation is required'
};
